import Cookies from 'universal-cookie'

const cookies = new Cookies();

const firstConnection = cookies.get('first_connection') === 'true' ? true : false;

const defaultState = {
    accessToken:'',
    firstConnection: firstConnection,
    connected: false,
    username: ''
};

export default function AccessToken(state = defaultState, action) {

    switch (action.type) {
        case "POST_TOKEN_SUCCESS": {

            cookies.set('refresh_token', action.results.refresh_token, {maxAge: action.results.refresh_expires_in});
            cookies.set('refresh_token_expires', action.results.refresh_expires_in);
            cookies.set('access_token', action.results.access_token, {maxAge: action.results.expires_in});
            cookies.set('isConnected', true, {maxAge: action.results.refresh_expires_in});
            if(!cookies.get('first_connection')) {
                cookies.set('first_connection', true);
            }
            return {
                ...state,
                firstConnection: cookies.get('first_connection')
            };
        }
        case "POST_TOKEN_ERROR": {

            console.log("POST_TOKEN_ERROR",action);
            return {
                ...state,
                connected:false
            };
        }

        case "GET_INFO_ME_SUCCESS": {

            cookies.set('user', action.results.userid);
            cookies.set('menus', action.results.menus);

            return {
                ...state,
                connected:true,
                username: action.results.userid
            };
        }
        case "GET_INFO_ME_ERROR": {

            console.log("GET_INFO_ME_ERROR",action);
            return {
                ...state,
                connected:false
            };
        }

        case "LOGOUT_SUCCESS": {

            cookies.set('access_token', null);
            cookies.set('refresh_token', null);
            cookies.set('menu_adocs', null);
            cookies.set('user', null);
            cookies.set('isConnected', false);
            cookies.set('menus', false);

            return {
                ...state,
                connected:false
            };
        }

        case "LOGOUT_ERROR": {
            return {
                ...state,
                connected:false
            };
        }

        case "REFRESH_TOKEN_ERROR": {
            cookies.set('access_token', null);
            cookies.set('refresh_token', null);
            cookies.set('menu_adocs', null);
            cookies.set('user', null);
            cookies.set('isConnected', false);

            return {
                ...state,
                connected:false
            };
        }

        case "GET_MENU_ASCIIDOC_SUCCESS": {

            cookies.set('menu_adocs', action.results);

            return {
                ...state,
                menuAdocs:action
            };
        }
        case "GET_MENU_ASCIIDOC_ERROR": {

            console.log("GET_ASCIIDOC_ERROR",action);
            return {
                ...state,
                menuAdocs:'error'
            };
        }

        default: return state;
    }
}
